import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#BCBCBC",
      d: "m11.897 6.233-3.6-4A.4.4 0 0 0 8 2.101H5.6a.401.401 0 0 0-.298.667L8.662 6.5l-3.36 3.732a.4.4 0 0 0 .298.668H8c.113 0 .22-.049.297-.132l3.6-4a.4.4 0 0 0 0-.535Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#BCBCBC",
      d: "m6.698 6.233-3.6-4a.4.4 0 0 0-.298-.132H.4a.401.401 0 0 0-.297.667L3.462 6.5l-3.36 3.732A.4.4 0 0 0 .4 10.9h2.4c.114 0 .221-.049.298-.132l3.6-4a.4.4 0 0 0 0-.535Z"
    }, null, -1)
  ]))]))
}
export default { render: render }